//* mv *//
jQuery(function(){	
  jQuery('.mv-slider ul').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 32000,
    cssEase: "linear",
    slidesToShow: 1,
    swipe: false,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false
  });
	jQuery('.content-bg ul').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 60000,
      infinite: true,
    cssEase: "linear",
      infinite: true,
    slidesToShow: 1,
    swipe: false,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false
  });
});
	



//* slider *//
jQuery(function(){	
	if(jQuery(window).width()<768){
		jQuery('.bag-slider').slick({
			arrows: true,
			dots: false,
			slidesToShow: 1,
		});
	}
});
	

//* スクロールすると表示アニメーション *//
jQuery(function() {
	jQuery('.fade,.fade01,.fade02,.fade03,.fade04,.blur,.zoom,.delay01,.delay02,.delay03,.delay04,.delay05').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if(isInView){
			jQuery(this).stop().addClass('mv');
		}
	});
});


